import { combineReducers, createStore } from 'redux';
import shoopReducer from '../reducers/shoopReduers';

const reducers = combineReducers({
    importShoops: shoopReducer,
})

export default createStore(reducers);